import React from 'react';
import NumericInput, { NumericInputProps } from '../NumericInput';

export type AppRateInputProps = Omit<NumericInputProps, 'thousandSeparator'>;

/**
 * Plain numeric input for rates, hours, units and counts. Sanitised (strips
 * commas/spaces, flags malformed values inline), keeps full precision and never
 * adds thousand separators ("10000" stays "10000"). Use `integer` for
 * whole-number counts. Commits the cleaned numeric string to the form.
 */
const AppRateInput: React.FC<AppRateInputProps> = (props) => (
  <NumericInput {...props} thousandSeparator={false} />
);

export default AppRateInput;
